import React from "react";

const initialContext = {
    history: [],
};

const historyContext = React.createContext(initialContext);

export { historyContext };
